import { cssVar } from '@mfw/common';
import type { Theme } from '@mui/material/styles';

import { buttonClasses } from '@mui/material/Button';
import { Iconify } from '@mfw/components';

// ----------------------------------------------------------------------

const dateList = [
  'DatePicker',
  'DateTimePicker',
  'StaticDatePicker',
  'DesktopDatePicker',
  'DesktopDateTimePicker',
  //
  'MobileDatePicker',
  'MobileDateTimePicker',
];

const timeList = [
  'TimePicker',
  'MobileTimePicker',
  'StaticTimePicker',
  'DesktopTimePicker',
];

const switchIcon = () => <Iconify icon="eva:chevron-down-fill" size="medium" />;

const leftIcon = () => <Iconify icon="eva:arrow-ios-back-fill" size="medium" />;

const rightIcon = () => (
  <Iconify icon="eva:arrow-ios-forward-fill" size="medium" />
);

const calendarIcon = () => (
  <Iconify icon="solar:calendar-mark-bold-duotone" size="medium" />
);

const clockIcon = () => (
  <Iconify icon="solar:clock-circle-outline" size="medium" />
);

const desktopTypes = dateList.reduce(
  (result: Record<string, any>, currentValue) => {
    result[`Mui${currentValue}`] = {
      defaultProps: {
        slots: {
          leftArrowIcon: leftIcon,
          openPickerIcon: calendarIcon,
          rightArrowIcon: rightIcon,
          switchViewIcon: switchIcon,
        },
      },
    };

    return result;
  },
  {},
);

const timeTypes = timeList.reduce(
  (result: Record<string, any>, currentValue) => {
    result[`Mui${currentValue}`] = {
      defaultProps: {
        slots: {
          openPickerIcon: clockIcon,
          rightArrowIcon: rightIcon,
          switchViewIcon: switchIcon,
        },
      },
    };

    return result;
  },
  {},
);

export function datePicker(theme: Theme) {
  return {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          '& .MuiPickersLayout-actionBar': {
            [`& .${buttonClasses.root}:last-of-type`]: {
              backgroundColor: cssVar.text.primary,
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.common.white
                  : theme.palette.grey[800],
            },
          },
        },
      },
    },

    // Date
    ...desktopTypes,

    // Time
    ...timeTypes,
  };
}
